import { Address } from "./address";
import { Language } from './language';

export class ServiceProvider {
    name: string;
    type: string;
    email: string;
    phone: string;
    logo: string;
    address: Address = new Address();
    language: string = "en";
    timeZone: any;
    timezone: string;
    id: number = null;
    accountIds: any[];
    aiMode: any;
    imageGrading: boolean = false;
    dateFormat: any;
    isLoginOTPRequired: Boolean = false;
    languageList: Language[] = [];
    expertReviewCategory: String = "";
    enableTreatmentStatus:boolean = false;
    enableCaseSearch: boolean = false;
}
